import { NgModule, inject } from "@angular/core";
import { APOLLO_OPTIONS, provideApollo } from "apollo-angular";
import { EnvironmentService } from "src/app/services/env/env.service";
import { GraphqlService } from "src/app/services/graphql/graphql.service";

export function createApollo(apolloOptionsService: GraphqlService) {
  return apolloOptionsService.createApollo();
}

export function getApolloOptions(apolloOptionsService: GraphqlService) {
  return apolloOptionsService.apolloOptions;
}

@NgModule({
  providers: [
    GraphqlService,
    {
      provide: APOLLO_OPTIONS,
      useFactory: getApolloOptions,
      deps: [GraphqlService, EnvironmentService],
    },
    provideApollo(() => {
      return createApollo(inject(GraphqlService));
    }),
  ],
})
export class GraphQLModule {}
